import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import cookie from "js-cookie";
import InputMask from 'react-input-mask';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart, faPaperPlane, faFileDownload } from "@fortawesome/free-solid-svg-icons";
import Icon from "../Icon";
import * as fbq from '../../lib/fpixel'
import Carousel from "react-elastic-carousel";
import Head from "next/head";
import Video from "../Video";
import StateSelect from "../AddressFields/StateSelect"

import { cartApi, requestProductsApi, juridicShippingApi } from "../../services/api";
import { productsApi } from "../../services/api";
import { useCart } from "../CartContext";
import { useUser } from "../UserContext";

import ExpandableImage from "./ExpandableImage";
import ExpandableVideo from "./ExpandableVideo";
import Title from "../Title";
import CTA from "../CTA";
import QuantitySelector from "../QuantitySelector";
import ProductItem from "../ProductItem";
import ClipLoader from "react-spinners/ClipLoader";

import {
  ProductInfos,
  Price,
  Tax,
  Description,
  Relateds,
  Thumbs,
  CartIcon,
  FormAddProduct,
  FormQuoteShippingTax,
  ZipSelector,
  DivShippingTax,
  DivDeliveryAt,
  Input,
  FormRequestProduct,
  InputSelect,
  InputTextArea,
  SendForm,
  DivSendForm,
  DivFile,
  FlagImage,
  Originlabel
} from "./styles";
import { Close, Modal } from "./ExpandableImage/styles";
import SouvRequest from "../SouvRequest";
import { Route } from "react-router";
import router from "next/router";

export default function ProductPageComponent({ product, relateds, token }) {

  const [quantity, setQuantity] = useState(1);
  const [widthProduct, setWidthProduct] = useState(1);
  const [heightProduct, setHeightProduct] = useState(1);
  const [zip, setZip] = useState();
  const [zipTaxValue, setZipTaxValue] = useState();
  const [zipDeadline, setZipDeadline] = useState();
  const [newZipTax, setNewZipTax] = useState(0);
  const [mainImage, setMainImage] = useState(
    product.images[0] || "/no-image.jpg"
  );

  const [name, setName] = useState();
  const [phone, setPhone] = useState();
  const [email, setEmail] = useState();
  const [type, setType] = useState("Pessoa Fisica");
  const [description, setDescription] = useState();
  const [sku, setSku] = useState(product.sku);
  const [newJuridcTax, setNewJuridicTax] = useState(0);
  const [newStateOfCompany, setNewStateOfCompany] = useState();
  const [stateOfCompany, setStateOfCompany] = useState();
  const [isVideo, setIsVideo] = useState(false);
  const [is3d, setIs3d] = useState(false);

  const [active, setActive] = useState(false);

  const [images, setImages] = useState(product.images);
  const { setCart } = useCart();
  const { user } = useUser();
  const [cartToken, setCartToken] = useState();

  useEffect(() => {
    setMainImage(product.images[0] || "/no-image.jpg");
    setImages(product.images);

    if (product.images[0]) {
      // run_carrousel(product.images[0]);
    }
  }, [product]);

  const currency = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL"
  });

  const currency_usd = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "USD"
  });

  function handleQuantityChange(e) {
    if (e.target.value >= 1) setQuantity(e.target.value);

    if (newZipTax == 1) {
      getShippingTax();
    }
  }

  function handleQuantityWidthProductChange(e) {
    if (e.target.value >= 1) setWidthProduct(e.target.value);


  }

  function handleQuantityHeightProductChange(e) {
    if (e.target.value >= 1) setHeightProduct(e.target.value);

  }

  function handleZipCodeChange(e) {
    const newZip = e.target.value.replace("-", "");
    setZip(newZip);
  }

  var moeda;
  async function handleSubmit(e) {
    e.preventDefault();
    { user && user.ex ? moeda = 'USD' : moeda = 'BRL' }
    fbq.addtocart(product, moeda);


    var amountWidth = widthProduct
    var amountHeight = heightProduct


    const newCart = await cartApi.add(product.id, quantity, amountHeight, amountWidth, {
      user_token: token,
      cart_token: cookie.get("cart_token")
    });
    cookie.set("cart_token", newCart['id'] ?? "", { expires: 30 });

    setCartToken(newCart['id']);
    setCart(newCart['items']);

    toast.success("Produto adicionado no Carrinho!",
      {
        position: "bottom-left",
        autoClose: 5000,
        closeOnClick: true,
        pauseOnHover: true,
        onClick: function () { goToCart() }
      });
  }

  function goToCart() {
    window.location.replace("/carrinho");
  }
  async function handleRequestSubmit(e) {
    e.preventDefault();

    const newRequestProduct = await requestProductsApi.store({
      name: name,
      phone: phone,
      sku: sku,
      email: email,
      type: type,
      description: description
    });

    toast.success("Contato enviado com sucesso!");

  }

  async function getShippingTax() {
    setNewZipTax(0);
    const ZipTax = await productsApi.productCustomerTax(product.id, {
      user_token: token,
      cart_token: cartToken,
      zip_code: zip,
      quantity: quantity
    });

    if (!ZipTax["error"]) {
      setNewZipTax(1);
      setZipDeadline(ZipTax["frete"][0]["prazo"]);
      setZipTaxValue(ZipTax["frete"][0]["vltotal"]);
    } else {
      toast.error("CEP não existente!");
    }
  }

  async function handleGetShippingTax(e) {
    e.preventDefault();

    getShippingTax();
  }

  function changeMainImage(img) {

    setImages([...product.images]);
    if (img == "video-player") {
      setIsVideo(true);
      setIs3d(false);
      setMainImage(product.url_video);
    } else if (img == "3d-model") {
      setIs3d(true);
      setIsVideo(false);
      setMainImage(product.three_dimensional);
    } else {
      setIsVideo(false);
      setIs3d(false);
      setMainImage(img);
    };
  }

  function run_carrousel(img) {
    if ((product.images.indexOf(img) + 1) > product.images.length - 1) {
      setMainImage(product.images[0]);
      const filtered = images.filter(image => image !== product.images[0]);

      setImages([...filtered, product.images[0]]);
      setTimeout(() => {
        run_carrousel(product.images[0])
      }, 3000);
    } else {
      var newImg = product.images[product.images.indexOf(img) + 1]
      setMainImage(newImg)
      const filtered = images.filter(image => image !== newImg);

      setImages([...filtered, newImg]);
      setTimeout(() => {
        run_carrousel(newImg)
      }, 3000);
    }


  }


  async function handleStateOfCompanyChange(e) {
    const value = e.target.value;

    setNewStateOfCompany(value);
    setNewJuridicTax(0);

    const fetchedJuridicShippingPrice = await juridicShippingApi.getByState({
      user_token: token,
      cart_token: cartToken,
      state_acronym: value,
      product: product.sku
    });

    setNewJuridicTax(1);
    setStateOfCompany(fetchedJuridicShippingPrice);

  }
  
  // async function getStoque() {
  //   productsApi.get_stock({ product: product.sku }).then(
  //     (response) => {
  //       const productStockSiger = response[0]['product_stock'];
  //       document.getElementById("product_stock").innerHTML = '<strong>Estoque: ' + productStockSiger + ' UN</strong>';
  //     }
  //   );
  // }

  if (product.stock) {
    var availability = "in stock";
  } else {
    var availability = "out of stock";
  }
  if (typeof window !== "undefined") {
    // getStoque();
    // if (user == null || user.profile == 'costumer') {
    //   fbq.viewcontent(product);
    // }
  }
  return (
    <article>
      {(!user || user?.profile == "costumer") ?
        <Head>
          <meta property="product:retailer_item_id" content={product.sku} />
          <meta property="og:title" content={product.name} />
          <meta property="og:description" content={product.description} />
          <meta property="og:url" content={"https://www.goodsbr.com.br/produtos" + product.slug} />
          <meta property="og:image" content={product.images} />
          <meta property="product:brand" content={"GoodsBr"} />
          <meta property="product:availability" content={availability} />
          <meta property="product:condition" content={"new"} />
          <meta property="product:price:amount" content={product.price} />
          <meta property="product:category" content={product.taxon_id} />
          <meta property="product:price:currency" content={"BRL"} />
          {/* <meta property="product:item_group_id" content={product.sku}/> */}
        </Head>
        : ""}



      <Title>{product.name}</Title>

      <ProductInfos>
        <div>
          <figure>
            <ExpandableImage src={mainImage} alt={product.name} video={isVideo} three_dimensional={is3d} />
          </figure>
          {((images.length >= 1) | (images.length >= 1 && product.origin)) ? (
            <Carousel itemsToScroll={1} itemsToShow={3}>
              {images.map((image) => (
                (image == mainImage) ? (
                  <figure style={{ border: "2px solid black" }} key={image} onClick={() => changeMainImage(image)}>
                    <img src={image} alt={product.name} />
                  </figure>
                ) : (
                  <figure key={image} onClick={() => changeMainImage(image)}>
                    <img src={image} alt={product.name} />
                  </figure>
                )
              ))}
              {product.url_video ?
                (product.url_video == mainImage) ? (
                  <figure style={{ border: "2px solid black" }} key="/video-player.png" onClick={() => changeMainImage("video-player")}>
                    <img src="/video-player.png" alt="feito no brasil" />
                  </figure>
                ) : (
                  <figure key="/video-player.png" onClick={() => changeMainImage("video-player")}>
                    <img src="/video-player.png" alt="feito no brasil" />
                  </figure>
                )
                :
                <>
                </>
              }
              {product.three_dimensional ?
                (product.three_dimensional == mainImage) ? (
                  <figure style={{ border: "2px solid black" }} key="/3d-model.png" onClick={() => changeMainImage("3d-model")}>
                    <img src="/3d-model.png" alt="feito no brasil" />
                  </figure>
                ) : (
                  <figure key="/3d-model.png" onClick={() => changeMainImage("3d-model")}>
                    <img src="/3d-model.png" alt="feito no brasil" />
                  </figure>
                )
                :
                <>
                </>
              }
            </Carousel>
          ) : ""}
          {/* {product.three_dimensional && (<div style={{width:"100%", height:"100%"}}><iframe width="100%" height="100%" src={product.three_dimensional} frameborder="0" allowfullscreen=""></iframe></div>)} */}
        </div>

        <div>
          {user ?
            ((product.price && product.stock && !product.partner_brands) || (product.price && product.sale_out_stock) || ((!user || user.profile == "costumer") && product.sale_out_stock_customer) || ((!user || user.profile == "corporate") && product.sale_out_stock_corporative)) && (
              <div>
                <Price>
                  {user && user.ex ? currency_usd.format(product.price) : currency.format(product.price)}
                  {(product.unity == "M2") &&
                    <span>m²</span>
                  }
                </Price>
                {product.tax > 0 && !user?.vip && (user?.profile == "shopkeeper") && !user.ex && (
                  <Tax>+ {product.tax}% de IPI</Tax>
                )}
              </div>
            )
            : ''
          }

          {(user && !(product.stock) && !(product.partner_brands) && !(product.sale_out_stock) && !((!user || user.profile == "costumer") && product.sale_out_stock_customer) && !((user && user.profile == "corporate") && product.sale_out_stock_corporative)) && (
            <div>
              <Price>
                Produto indisponível
              </Price>
            </div>
          )}

          {user && (product.partner_brands && !product.sale_out_stock && !((!user || user.profile == "costumer") && product.sale_out_stock_customer) && !((user && user.profile == "corporate") && product.sale_out_stock_corporative)) && (
            <div>
              <Price>
                Produto sob consulta
              </Price>
            </div>
          )}



          {(user && user?.profile != "costumer" && product.min_amount) ?
            <>
              <div><span>Valor unitário: {user && user.ex ? currency_usd.format(product.price / product.min_amount) : currency.format(product.price / product.min_amount)}</span></div>
            </> : ""}
          <span>Referência: {product.sku}</span>


          
          {product.description && (
            <Description>
              {product.description.split("  ").reduce(
                (r, a) =>
                  r.concat(
                    a,
                    <>
                      <br />
                    </>
                  ),
                []
              )}
            </Description>
          )}

          {/* { ( product.delivery_time > 6 ) ?
            <>
              <DivDeliveryAt>
                <span><strong>Tempo de produção e entrega: {product.delivery_time} dias</strong></span>
              </DivDeliveryAt>
            </> : ""
          } */}
          {(product.whatsapp_phone && user?.profile != "shopkeeper") ?
            <>
              <DivDeliveryAt Style="align-items: center;
    display: flex;
    justify-content: space-evenly;">
                <span>Entre em contato para saber mais: </span>
                <a target="_blank" href={"https://api.whatsapp.com/send?phone=55" + product.whatsapp_phone + "&text=Ola, tudo bem ? \n Produto " + product.sku}><img Style="width: 30px" src="https://www.iconfinder.com/data/icons/brands-applications/512/Whatsapp-512.png" /></a>
              </DivDeliveryAt>
            </> : ""
          }

          {(user && user?.profile != "costumer" && product.min_amount) ?
            <>
              <DivDeliveryAt>
                <span><strong>Valor correspondente a {product.min_amount} unidades na caixa fechada.</strong></span>
              </DivDeliveryAt>
            </> : ""
          }

          {(user && user?.company_user == true && product.delivery_at) &&
            <>
              <DivDeliveryAt>
                <span><strong>Encomenda existente!</strong></span>
                <br />
                <span><strong>Entrega prevista após: {product.delivery_at}</strong></span>
                <br />
                <span><strong>Quantidade da encomendo: {product.shipped}</strong></span>
                <br />
              </DivDeliveryAt>
            </>
          }
          {(product.weight) &&
            <>
              <div>
                <span Style="color: black;"><strong>Peso: </strong>{product.weight}</span>
              </div>
            </>
          }
          {(product.measure) &&
            <>
              <div>
                <span Style="color: black;"><strong>Medida: </strong>{product.measure}</span>
              </div>
            </>
          }
          {(product.material) &&
            <>
              <div>
                <span Style="color: black;"><strong>Material: </strong>{product.material}</span>
              </div>
            </>
          }

          {(user && user?.company_user == true && product.stock_final > 0) &&
            <>
              <DivDeliveryAt>
                <div>
                  <span> Atenção: essa informação vem diretamente do SIGER, campo quantidade livre </span>
                </div>
                <div>
                  <span id='product_stock'><strong><ClipLoader color={'#F37A24'} loading={true} size={50} /></strong></span>
                </div>
              </DivDeliveryAt>
            </>
          }

          {(user && product.manufacturing_time && product.stock == false) &&
            <>
              <DivDeliveryAt>
                <span><strong>Tempo de produção: {product.manufacturing_time} dias</strong></span>
              </DivDeliveryAt>
            </>
          }

          {(product.origin) &&
            <>
              <Originlabel>
                <FlagImage src="/feito-no-brasil-goods-br.png" style={{ marginRight: "10px" }} />
                <span><strong>Produto de origem Nacional</strong></span>
              </Originlabel>
            </>
          }


          {/* { ( product.video_url ) &&
            <>
              <ExpandableVideo src={product.video_url}/>
            </>
          } */}

          {/* {(product.delivery_type && ((!user || user.profile == "costumer") && (product.stock || product.sale_out_stock_customer))) && */}
          {(user && (product.stock || product.sale_out_stock_customer)) &&
            <>
              <DivShippingTax>
                <span>Calcular frete Goods Br</span>
              </DivShippingTax>
              <DivDeliveryAt >
                <FormQuoteShippingTax>
                  <StateSelect
                    name="state"
                    onChange={handleStateOfCompanyChange}
                  />
                </FormQuoteShippingTax>
                {stateOfCompany != null ? <p><strong>Valor do frete: {currency.format(parseFloat(stateOfCompany))}</strong></p> : ""}

              </DivDeliveryAt>
            </>
          }

          {/* {
            ((product.stock || product.sale_out_stock) && !product.partner_brands && !product.delivery_type && user?.profile != "shopkeeper") &&
            <>
              <DivShippingTax>
                <span>Calcular frete e prazo</span>
              </DivShippingTax>
              <FormQuoteShippingTax>
                <InputMask mask="99999-999" onChange={handleZipCodeChange} >
                  <ZipSelector />
                </InputMask>

                <CTA button onClick={handleGetShippingTax}>
                  <div Style="display: flex; align-items: center;">
                    OK
                  </div>
                </CTA>
              </FormQuoteShippingTax>
            </>
          } */}


          {(user && user?.profile != "costumer" && product.stock) ? "" : (newZipTax == 1 && product.stock) && (<span>Entregue por: Jadlog</span>)}

          {(user && user?.profile != "costumer" && product.stock) ? "" : (newZipTax == 1 && product.stock) &&
            (<div><span>Valor de frete: {new Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL"
            }).format(zipTaxValue)}</span></div>
            )}
          {(user && user?.profile != "costumer" && product.stock) ? "" : (newZipTax == 1 && product.stock) && (<div><span>Quantidade: {quantity}</span></div>)}
          {(user && user?.profile != "costumer" && product.stock) ? "" : (newZipTax == 1 && product.stock) && (<span>Entregue em até: {zipDeadline + 3} dias</span>)}

          {((!user?.vip && product.stock && !product.partner_brands || !user?.vip && product.sale_out_stock) || ((!user || user.profile == "costumer") && product.sale_out_stock_customer) || ((user && user.profile == "corporate") && product.sale_out_stock_corporative)) && (
            user ?

              <FormAddProduct>
                Quantidade:{" "}

                {product.unity == "M2" &&
                  <>
                    <QuantitySelector
                      name="widthProduct"
                      value={widthProduct}
                      onChange={handleQuantityWidthProductChange}
                    />
                    X
                    <QuantitySelector
                      name="heightProduct"
                      value={heightProduct}
                      onChange={handleQuantityHeightProductChange}
                    />
                    <br></br>
                  </>
                }

                {product.unity != "M2" &&
                  <QuantitySelector
                    value={quantity}
                    onChange={handleQuantityChange}
                  />
                }

                <CTA button onClick={handleSubmit}>
                  <div Style="display: flex; align-items: center;">
                    <CartIcon>
                      <FontAwesomeIcon icon={faShoppingCart} />
                    </CartIcon>
                    Comprar
                  </div>
                </CTA>


              </FormAddProduct>
              : ''

          )}
          {product.unity == "M2" &&
            <>
              <span>Total do tapete: </span>
              <Price>
                <span>
                  {user && user.ex ? currency_usd.format((heightProduct * widthProduct) * product.price) : currency.format((heightProduct * widthProduct) * product.price)}
                </span>
              </Price>
            </>
          }

          {/* {((!product.stock || product.partner_brands) && !product.sale_out_stock && !((!user || user.profile == "costumer") && product.sale_out_stock_customer) && !((user && user.profile == "corporate") && product.sale_out_stock_corporative)) && (
            <FormRequestProduct>
              <h2>Entre em contato:</h2><div></div>
              <span>Nome: </span><Input type="text" name="name" onChange={e => setName(e.target.value)} ></Input>
              <span>Telefone/Whatsapp: </span><InputMask mask="(99) 9 9999-9999" onChange={e => setPhone(e.target.value)} ><Input type="tel" name="phone" ></Input></InputMask>
              <span>Email: </span><Input type="text" name="email" onChange={e => setEmail(e.target.value)} ></Input>
              <span>Tipo: </span><InputSelect type="select" onChange={e => setType(e.target.value)} name="type">
                <option value="Pessoa Fisica" > Pessoa Fisica</option>
                <option value="Pessoa Juridica" > Pessoa Juridica</option>
              </InputSelect>
              <span>Mensagem: </span>
              <InputTextArea onChange={e => setDescription(e.target.value)} name="description"></InputTextArea>


              <CTA button onClick={handleRequestSubmit}>
                <DivSendForm>
                  <SendForm size="21">
                    <FontAwesomeIcon icon={faPaperPlane} />
                  </SendForm>
                  <span>Enviar</span>
                </DivSendForm>
              </CTA>
            </FormRequestProduct>

          )} */}
        </div>

        {/* {(product.document && product.button_download_document) && */}
        {/* <a target="_blank" href={product.document}> */}
        {/* <CTA button> */}
        {/* <DivFile> */}
        {/* <SendForm size="21"> */}
        {/* <FontAwesomeIcon icon={faFileDownload} /> */}
        {/* </SendForm> */}
        {/* <Icon size="21">
                    <FontAwesomeIcon icon={faFileDownload} />
                  </Icon> */}
        {/* {product.button_download_document} */}
        {/* </DivFile> */}
        {/* </CTA> */}
        {/* </a> */}
        {/* } */}

      </ProductInfos>

      {(relateds.length > 0) && (
        <Relateds>
          <h2>Produtos Relacionados</h2>
          <div>
            {relateds.map(related => (
              <ProductItem key={related.slug} product={related} />
            ))}
          </div>
        </Relateds>
      )}
    </article>
  );
}
